export const SESSION_EXPIRED_EVENT = 'veltiz:session-expired';

export function emitSessionExpired(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}
